import { defineComponent as _defineComponent } from 'vue'
import moment from 'moment';
import { computed, ref, getCurrentInstance } from 'vue';

import { useBilling } from '@/components/Billing/Billing.composables';
// @ts-ignore
import BillingDowngradePending from '@/components/Billing/BillingDowngradePending.vue';
import BillingService from '@/components/Billing/billing-service';
import { DATE_FORMAT_DISPLAY } from '@/components/Billing/billing-service.const';
import { FeatureTypes, ProductType } from '@/components/Billing/billing-types';

export default /*#__PURE__*/_defineComponent({
  __name: 'BillingDowngradePendingDataProvider',
  props: {
    productType: null
  },
  setup(__props: any) {

const props = __props as {
	productType: ProductType;
}


const toast = getCurrentInstance()?.proxy.$toast;
const { cancelProductDowngrade, useSubscriptionByProductType, usePlanById, useEntitlementById } = useBilling();
const planById = usePlanById();
const entitlementById = useEntitlementById();
const subscription = computed(() => useSubscriptionByProductType.value(props.productType));
const downgradeUpdate = computed(() => BillingService.getDowngradeUpdate(subscription.value));
const downgradePlanReadableName = computed(() => {
	const relevantPlanId = downgradeUpdate.value.scheduleVariables.downgradePlanRefId || planId.value;
	const quantity =
		downgradeUpdate.value.scheduleVariables.newUnitAmount || BillingService.getPlanUsageLimit(planById.value(relevantPlanId));
	return BillingService.getPlanReadableName({
		quantity,
		planId: relevantPlanId,
		productType: props.productType,
	});
});
const planId = computed(() => BillingService.getSubscriptionPlanId(subscription.value, true));
const quantity = computed(() => {
	if (ProductType.TeamFeatures === props.productType) {
		return 0;
	}
	if (ProductType.Automation === props.productType) {
		const entitlement = entitlementById.value(FeatureTypes.AutomationTasks);
		if (!entitlement) {
			return 0;
		}
		return BillingService.getSubscriptionSliderValue(subscription.value, planById.value, true, entitlement);
	}
	if (ProductType.Credits === props.productType) {
		const entitlement = entitlementById.value(FeatureTypes.Credits);
		if (!entitlement) {
			return 0;
		}
		return BillingService.getSubscriptionSliderValue(subscription.value, planById.value, true, entitlement);
	}

	if (ProductType.CustomerFeatures === props.productType) {
		const entitlement = entitlementById.value(FeatureTypes.CustomerTasks);
		if (!entitlement || !subscription.value) {
			return 0;
		}
		return BillingService.getCustomerFeatureUsageLimit(subscription.value, true, entitlement);
	}
	return 0;
});
const planReadableName = computed(() =>
	BillingService.getPlanReadableName({ planId: planId.value, quantity: quantity.value, productType: props.productType })
);
const downgradeReadableDate = computed(() => moment(downgradeUpdate.value.scheduledExecutionTime).format(DATE_FORMAT_DISPLAY));
const isLoading = ref(false);
const cancelDowngrade = async () => {
	try {
		isLoading.value = true;
		await cancelProductDowngrade(props.productType);
	} catch (e) {
		console.error('Error cancelling downgrade', e);
		toast?.error('Error occurred while cancelling downgrade. Please try again later, or contact our support team.');
	} finally {
		isLoading.value = false;
	}
};

return { __sfc: true,props, toast, cancelProductDowngrade, useSubscriptionByProductType, usePlanById, useEntitlementById, planById, entitlementById, subscription, downgradeUpdate, downgradePlanReadableName, planId, quantity, planReadableName, downgradeReadableDate, isLoading, cancelDowngrade, BillingDowngradePending }
}

})